export const chatInputWidth = 580
export const chatInputMaxRows = 6
export const proactiveInsightsPrompt = 'Show me my proactive insights'
